module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "请假 / 旷课影响",
      "tags": ['老师请假 + 旷课', '3 小时线'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('filter-pills', {
    attrs: {
      "options": _vm.dayOptions,
      "label": "时间窗口"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 关键不是请假多少，而是来不及代课的有多少：3 小时外安排代课，3 小时内不安排代课")])], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false), [(card.key === 'scope') ? _c('div', {
      staticClass: "kpi-split"
    }, [_c('div', [_c('div', {
      staticClass: "kpi-split-value"
    }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.studentCount))), _c('small', [_vm._v("人")])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-split-label"
    }, [_vm._v("学生（去重）")])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-split-right"
    }, [_c('div', {
      staticClass: "kpi-split-value is-warning"
    }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.lessonCount))), _c('small', [_vm._v("课节")])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-split-label"
    }, [_vm._v("受影响课节")])])]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("3 小时是硬边界：3 小时外系统安排代课，3 小时内没有兜底。系统里家长取消与改期补回无法区分，结果只分「成功代课 / 未代课」。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "compare-boxes"
  }, [_c('div', {
    staticClass: "compare-box"
  }, [_c('div', {
    staticClass: "compare-box-title is-healthy"
  }, [_vm._v("3 小时外请假")]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-value"
  }, [_vm._v(_vm._s(_vm.fmtRateNum(_vm.d.outerLossRate))), _c('small', [_vm._v("% 未代课率")])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-foot"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.outerCount)) + " 课节 · 代课率 " + _vm._s(_vm.fmtRate(_vm.d.outerProxyRate)))])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box is-danger"
  }, [_c('div', {
    staticClass: "compare-box-title is-danger"
  }, [_vm._v("3 小时内请假 / 旷课")]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-value is-danger"
  }, [_vm._v(_vm._s(_vm.fmtRateNum(_vm.d.innerLossRate))), _c('small', [_vm._v("% 未代课率")])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-foot"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.innerCount)) + " 课节 · 占受影响 " + _vm._s(_vm.fmtRate(_vm.d.innerShare)))])])]), _vm._v(" "), (_vm.num(_vm.d.lossCount) > 0) ? _c('div', {
    staticClass: "note is-danger"
  }, [_c('b', [_vm._v("3 小时内的课节只占 " + _vm._s(_vm.fmtRate(_vm.d.innerShare)) + "，却贡献了 " + _vm._s(_vm.fmtRate(_vm.d.innerLossShare)) + " 的未代课。")]), _vm._v("这部分不安排代课，没有系统兜底。\n        ")]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('dl', {
    staticClass: "kv"
  }, [_c('dt', [_vm._v("3h 内调度策略")]), _c('dd', [_vm._v("不安排代课")]), _vm._v(" "), _c('dt', [_vm._v("3h 内未代课")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.innerLossCount)) + " 课节")]), _vm._v(" "), _c('dt', [_vm._v("旷课未代课率")]), _c('dd', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.absentLossRate)) + "（占 " + _vm._s(_vm.fmtRate(_vm.d.absentShare)) + " 课节）")]), _vm._v(" "), _c('dt', [_vm._v("请假 / 旷课事件")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.eventCount)) + " 次 · 次均 " + _vm._s(_vm.fmtNum(_vm.d.avgLessonsPerEvent)) + " 课节")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("提前时长 × 处理结果"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("受影响课节 " + _vm._s(_vm.fmtNum(_vm.d.lessonCount)))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.bucketRows,
      "unit": "",
      "label-width": 92,
      "right-width": 130
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bucket-axis",
    style: ({
      paddingLeft: '102px',
      paddingRight: '140px'
    })
  }, [_c('span', [_vm._v("◀ 3 小时外 · 系统安排代课")]), _vm._v(" "), _c('span', {
    staticClass: "is-danger"
  }, [_vm._v("3 小时线")]), _vm._v(" "), _c('span', [_vm._v("3 小时内 · 不安排代课 ▶")])]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("提前时长 = 课节开始时间 − 老师最早一条请假申请时间。「无申请记录」= 状态为请假但查不到申请，只计入总量，不进 3 小时拆分。")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("周趋势看整体是否恶化；高频被请假学生按风险排序，新生优先置顶。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), (!_vm.weekly.length) ? _c('div', {
    staticClass: "chart-empty"
  }, [_vm._v("暂无数据")]) : _c('svg', {
    staticClass: "svg-chart",
    attrs: {
      "viewBox": '0 0 ' + _vm.trend.W + ' ' + _vm.trend.H
    }
  }, [_vm._l((_vm.trend.grid), function(g) {
    return _c('g', {
      key: 'g' + g.y
    }, [_c('line', {
      staticClass: "gridline",
      attrs: {
        "x1": _vm.trend.PL,
        "y1": g.y,
        "x2": _vm.trend.W - _vm.trend.PR,
        "y2": g.y
      }
    }), _vm._v(" "), _c('text', {
      staticClass: "axis-l",
      attrs: {
        "x": _vm.trend.PL - 8,
        "y": g.y + 3,
        "text-anchor": "end"
      }
    }, [_vm._v(_vm._s(g.label))])])
  }), _vm._v(" "), _vm._l((_vm.trend.lessons), function(p) {
    return _c('text', {
      key: 'x' + p.label,
      staticClass: "axis-l",
      attrs: {
        "x": p.x,
        "y": _vm.trend.H - _vm.trend.PB + 16,
        "text-anchor": "middle"
      }
    }, [_vm._v(_vm._s(p.label))])
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.trend.area,
      "fill": "#E89F2D",
      "fill-opacity": "0.08"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.trend.lessonPath,
      "fill": "none",
      "stroke": "#E89F2D",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.trend.lossPath,
      "fill": "none",
      "stroke": "#E6464E",
      "stroke-width": "2",
      "stroke-dasharray": "4 3"
    }
  }), _vm._v(" "), _vm._l((_vm.trend.lessons), function(p) {
    return _c('circle', {
      key: 'a' + p.label,
      attrs: {
        "cx": p.x,
        "cy": p.y,
        "r": "2.6",
        "fill": "#fff",
        "stroke": "#E89F2D",
        "stroke-width": "1.6"
      }
    }, [_c('title', [_vm._v(_vm._s(p.title))])])
  }), _vm._v(" "), _vm._l((_vm.trend.loss), function(p) {
    return _c('circle', {
      key: 'b' + p.label,
      attrs: {
        "cx": p.x,
        "cy": p.y,
        "r": "2.6",
        "fill": "#fff",
        "stroke": "#E6464E",
        "stroke-width": "1.6"
      }
    }, [_c('title', [_vm._v(_vm._s(p.title))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("高频被请假学生"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.studentSub))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_vm._l((_vm.students), function(row) {
    return _c('tr', {
      key: row.uid,
      class: {
        'is-priority': row.newPriority
      }
    }, [_c('td', [_c('span', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.userName || '—'))]), _c('span', {
      staticClass: "t-id"
    }, [_vm._v(_vm._s(row.uid))])]), _vm._v(" "), _c('td', [(row.newPriority) ? _c('span', {
      staticClass: "badge is-danger"
    }, [_vm._v("新生优先")]) : (row.isNew) ? _c('span', {
      staticClass: "badge is-warning"
    }, [_vm._v("新生")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "t-muted"
    }, [_vm._v(_vm._s(_vm.isNum(row.tenureDays) ? '开课第 ' + row.tenureDays + ' 天' : '—'))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', [_vm._v(_vm._s(_vm.fmtNum(row.leaveCount)))])]), _vm._v(" "), _c('td', {
      staticClass: "num",
      class: {
        't-danger': _vm.num(row.innerCount) > 0
      }
    }, [_vm._v(_vm._s(_vm.fmtNum(row.innerCount)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.lessonCount)))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, _vm._l(((row.dates || [])), function(dt, idx) {
      return _c('span', {
        key: idx,
        staticClass: "mini-badge",
        class: dt.inner ? 'is-inner' : 'is-outer'
      }, [_vm._v(_vm._s(_vm.shortDate(dt.date)))])
    }), 0), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(row.level)
    }, [_vm._v(_vm._s(row.level || '—'))])])])
  }), _vm._v(" "), (!_vm.students.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("当前窗口内无高频被请假学生")])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.studentInsight) ? _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v(_vm._s(_vm.studentInsight))]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("3 小时线")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("核心对照")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v("既然 3 小时内不做代课，"), _c('b', [_vm._v("唯一可控的杠杆是改约")]), _vm._v("：把自助改约入口和改约话术做进家长端，比建应急代课池更直接。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "chart-legend"
  }, [_c('span', [_c('i', {
    staticClass: "is-proxy"
  }), _vm._v("成功代课")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "is-loss"
  }), _vm._v("未代课")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("趋势与高频学生")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("周趋势"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("截至今天近 10 个 ISO 周")])]), _vm._v(" "), _c('span', {
    staticClass: "chart-legend"
  }, [_c('span', [_c('i', {
    staticClass: "is-lessons"
  }), _vm._v("受影响课节")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "is-loss"
  }), _vm._v("未代课")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("学生")]), _vm._v(" "), _c('th', [_vm._v("新生状态")]), _vm._v(" "), _c('th', [_vm._v("主老师")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("被请假次数")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("3h内")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("影响课节")]), _vm._v(" "), _c('th', [_vm._v("老师请假日期")]), _vm._v(" "), _c('th', [_vm._v("风险")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22827b0b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tchImpact/TchImpactLeave.vue
// module id = 1694
// module chunks = 8